import { Button } from '@cred/neopop-web/lib/components';
import 'firebase/compat/auth';
import { useNavigate } from "react-router-dom";

const EventCard = ({ id, title, desc, price, logo_url }) => {

	const navigate = useNavigate();

	const handleClick = () => {
		navigate(`/${id}`);
	}

	return (
		<div className="bg-white w-72 h-[22em] flex flex-col items-center rounded-md my-16 mx-10">
			<div onClick={handleClick} className="bg-black w-[95%] h-[10em] flex items-center justify-center cursor-pointer rounded-md my-2">
				<img
					className=" object-cover rounded-md relative bottom-[30%]"
					src={logo_url}
					alt="card"
				/>
			</div>
			<div className="w-[93%]">
				<h3 className="text-black text-2xl uppercase font-bold my-2">{title}</h3>
				<p className="text-black text-md my-2 pb-2">{desc}</p>
				<div className="flex justify-between items-baseline">
					<h3 className="text-black text-2xl font-extrabold">₹{price}</h3>
					<Button
						variant="primary"
						kind="elevated"
						size="medium"
						colorMode="dark"
						onClick={handleClick}
					>
						Learn More
					</Button>
				</div>
			</div>
		</div>
	);
};

export default EventCard;
